// extracted by mini-css-extract-plugin
export default {"tab_bar":"styles_tab_bar__lH-G2","tab_button_text":"styles_tab_button_text__jlhxw","tab":"styles_tab__i41iF"};